












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Draggable extends Vue {
  // Props
  @Prop({ default: "tr" })
  public readonly tag!: string;

  @Prop({ required: true })
  public readonly index!: number;

  @Prop({ required: true })
  public readonly item!: any;

  // Data
  public oldIndex = this.index;
  public newIndex = this.index;
  public oldItem = this.item;
  public newItem = this.item;
  public isDragging = false;

  // Methods

  public onDragStart() {
    this.isDragging = true;
  }

  public onDragEnd() {
    this.isDragging = false;
    const payload = {
      oldItem: this.oldItem,
      newItem: this.newItem,
      oldIndex: this.oldIndex,
      newIdex: this.newIndex,
      isDragging: this.isDragging
    };
    this.$emit("drag-end", payload);
  }

  public onDragEnter() {
    this.$_.find(this.$parent.$children, sibling => {
      const draggable = sibling as Draggable;
      if (draggable?.isDragging) {
        draggable.newIndex = this.index;
        draggable.newItem = this.item;
      }
    });
  }
}
